import { RDLolFarmId } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { RDLolFarmIdTaskEditor } from './RDLolFarmIdTaskEditor'

export const RDLolFarmIdResourceDetailFeature: ResourceDetailFeature<RDLolFarmId> = {
  traitId: 'lolFarmId',
  TaskEditor: RDLolFarmIdTaskEditor,
}
